module.exports = __webpack_public_path__ + "img/00_Fragezeichen.81e2d206.svg";